export default __webpack_public_path__ + "images/835f2a08ed248b7ce9dc78c53dbc48da.png";